<template>
  <q-card class="glasscard" elevation="2">
    <q-card-section v-if="caption" class="row justify-between q-py-sm q-px-sm items-center" :class="'bg-' + color">
      <div class="text-body1 q-mb-none text-white" style="line-height: 1rem">
        <q-icon v-if="icon" :name="icon" size="16px" class="q-mr-xs"></q-icon> {{ caption }}
      </div>
      <slot name="top-right"></slot>
    </q-card-section>
    <q-card-section>
      <slot></slot>
    </q-card-section>
  </q-card>
</template>

<script setup>
defineProps({
  color: { type: String, default: "secondary" },
  caption: { type: String },
  icon: { type: String },
});
</script>

<style lang="scss">
.q-card.glasscard {
  border-radius: 12px;
}
.has-background .q-card.glasscard {
  backdrop-filter: blur(12px) saturate(180%);
  -webkit-backdrop-filter: blur(12px) saturate(180%);
  background-color: rgba(255, 255, 255, 0.9);
}

.body--dark .has-background .q-card.glasscard {
  background-color: rgba(38, 50, 56, 0.75);
}

.glasscard .v-label {
  font-size: 0.8rem;
}
</style>
